import { render, staticRenderFns } from "./EquipmentInfoContainer.vue?vue&type=template&id=2c1f431d&"
import script from "./EquipmentInfoContainer.vue?vue&type=script&lang=js&"
export * from "./EquipmentInfoContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c1f431d')) {
      api.createRecord('2c1f431d', component.options)
    } else {
      api.reload('2c1f431d', component.options)
    }
    module.hot.accept("./EquipmentInfoContainer.vue?vue&type=template&id=2c1f431d&", function () {
      api.rerender('2c1f431d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/equipment/components/EquipmentInfoContainer.vue"
export default component.exports